export { default as PriceTag } from './PriceTag';
